import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const SvgSignal3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 8h2v12h-2zM5 16h2v4H5zM9 12h2v8H9z" />
  </svg>
);
const Memo = memo(SvgSignal3);
export default Memo;
